import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { createPortal } from "react-dom"
import { Link } from "react-router-dom"

function PopupBanner({ onClose }) {
  const location = useLocation()
  const isAllowedPage =
    location.pathname.startsWith("/form/account_preferences/") ||
    location.pathname.startsWith("/account/2fa")

  useEffect(() => {
    if (!isAllowedPage) {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isAllowedPage])

  if (isAllowedPage) return null

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: "20px",
          }}
        >
          Your account is required to have Two-Factor Authentication enabled.
          <div>
            <Link
              style={{
                fontSize: "20px",
                marginTop: "9px",
              }}
              to={`/account/2fa/settings`}
              className="btn"
            >
              Configure
            </Link>
          </div>
        </p>
      </div>
    </div>,
    document.body
  )
}

export default PopupBanner
